<template>
  <section class="content">
    <div class="container-fluid">
      <div class="block-header">
        <h2>{{ nama }}</h2>
      </div>
      <div class="card">
        <div class="header">
          <h2>List {{ nama }}</h2>
          <ul class="header-dropdown m-r--5 m-t--10">
            <router-link
              :to="'/main/' + link + '/tambah'"
              class="btn btn-primary waves-effect"
              v-waves
            >
              <i class="material-icons" style="color: #fff;">add_box</i>
              <span>Tambah</span>
            </router-link>
          </ul>
        </div>
        <div class="body">
          <div class="dataTables_wrapper">
            <!-- Filter -->
            <div class="row">
              <div class="col-sm-6">
                <label>
                  Show
                  <select v-model="perPage" class="form-control input-sm">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                  entries
                </label>
              </div>
              <div class="col-sm-6">
                <label>
                  Search:
                  <input v-model="search" type="search" class="form-control input-sm" />
                </label>
              </div>
            </div>

            <!-- Table -->
            <table class="table table-bordered table-striped table-hover">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Menu Induk</th>
                  <th>Submenu</th>
                  <th>Gambar</th>
                  <th>Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="isLoading">
                  <td colspan="5" class="text-center">
                    <i class="fa fa-spin fa-spinner"></i> Loading...
                  </td>
                </tr>
                <tr v-if="!isLoading && list.length === 0">
                  <td colspan="5" class="text-center">Data tidak ditemukan</td>
                </tr>
                <tr v-for="(sub, index) in list" :key="sub.id">
                  <td>{{ index + 1 + ((currentPage - 1) * perPage) }}</td>
                  <td>{{ sub.parentName }}</td>
                  <td><strong>{{ sub.name }}</strong></td>
                  <td>
                    <img
                      v-if="sub.backgroundImage"
                      :src="sub.backgroundImage"
                      alt="gambar"
                      style="width: 100px;"
                    />
                  </td>
                  <td>
                    <button
                      @click="$router.push('/main/' + link + '/edit/' + sub.id)"
                      class="btn bg-green waves-effect"
                    >
                      <i class="material-icons">create</i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Pagination -->
            <div class="text-center" v-if="result.totalPages > 1">
              <ul class="pagination">
                <li :class="{ disabled: currentPage === 1 }">
                  <a href="#" @click.prevent="currentPage > 1 && (currentPage--, getData())">«</a>
                </li>
                <li
                  v-for="page in result.totalPages"
                  :key="page"
                  :class="{ active: currentPage === page }"
                >
                  <a href="#" @click.prevent="changePage(page)">{{ page }}</a>
                </li>
                <li :class="{ disabled: currentPage === result.totalPages }">
                  <a href="#" @click.prevent="currentPage < result.totalPages && (currentPage++, getData())">»</a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
/* eslint-disable */

import api from '@/helper/api'
import qs from 'qs'

export default {
  name: 'ListBanner',
  data () {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      isLoading: true,
      link: '',
      nama: 'Banner'
    }
  },
  methods: {
    getData () {
      this.isLoading = true
      const params = {
        search: this.search,
        page: this.currentPage - 1, // Server biasanya 0-based
        size: this.perPage
      }

      api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')

      api.get('/getAllNavbar?' + qs.stringify(params))
        .then((response) => {
          this.result = response.data
          this.list = this.flattenSubmenus(response.data.content)
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
          this.$toastr.e('Gagal mengambil data.')
        })
    },

flattenSubmenus(menuList) {
  let flattened = [];

  const recurse = (submenus, parentName) => {
    submenus.forEach(sub => {
      flattened.push(
        Object.assign({}, sub, {
          parentName: parentName || 'Menu Utama'
        })
      );

      if (sub.submenu && sub.submenu.length > 0) {
        recurse(sub.submenu, sub.title);
      }
    });
  };

  recurse(menuList);
  return flattened;
},

    changePage (page) {
      if (page !== this.currentPage) {
        this.currentPage = page
        this.getData()
      }
    },
    checkRoute (route) {
      if (route.name === 'ListBanner') {
        console.log("ini routenyar",route.name)
        this.link = 'banner'
      }
    },
  },
  mounted () {
    this.checkRoute(this.$route)  // ← WAJIB DIPANGGIL
    
    this.getData()
    
  },
  watch: {
    perPage () {
      this.currentPage = 1
      this.getData()
    },
    search () {
      this.currentPage = 1
      this.getData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/Banners/ListBanner.vue